import { Heading, TextPassage } from '@petsmart-ui/sparky';

import { AUTOSHIP_RECURRING_ORDERS_DISCOUNT } from '@libs/core';

import './AutoshipInfoDrawer.scss';

type AutoshipDiscountContentProps = {
    discount: string;
    maxSavings: string;
};

export const AutoshipMapRestrictedContent = () => (
    <>
        <Heading tagName="h4" size="headline">
            Subscribe with Autoship
        </Heading>
        <TextPassage className="autoship-info-drawer__dynamic-discount">
            Future orders ship to you on your schedule
        </TextPassage>
    </>
);

export const AutoshipFirstTimeEligibleContent = ({ discount, maxSavings }: AutoshipDiscountContentProps) => (
    <>
        <Heading tagName="h4" size="headline">
            How to Autoship & save
        </Heading>
        <TextPassage>
            <strong>{`Save ${discount}`}</strong> on your first Autoship order (up to {maxSavings})
        </TextPassage>
        <TextPassage className="autoship-info-drawer__dynamic-discount">
            <strong>{`${AUTOSHIP_RECURRING_ORDERS_DISCOUNT} off`}</strong> on future orders
        </TextPassage>
    </>
);

export const AutoshipExistingSubscriberContent = ({ discount, maxSavings }: AutoshipDiscountContentProps) => (
    <>
        <Heading tagName="h4" size="headline">
            How to Autoship & save
        </Heading>
        <TextPassage>
            <strong>{`Save ${discount}`}</strong> on your Autoship order (up to {maxSavings})
        </TextPassage>
        <TextPassage className="autoship-info-drawer__dynamic-discount">
            <strong>{`${AUTOSHIP_RECURRING_ORDERS_DISCOUNT} off`}</strong> on future orders
        </TextPassage>
    </>
);
